import { EyeClosed, EyeOpened, IconButton, getHiddenAmount } from '@airtm/airtm-ui';

type Props = {
  breakdownTotalBalanceLabel: string;
  balance: string;
  onToggleShowHideBalance: () => void;
  hideBalances: boolean;
};

const Balance = function ({
  breakdownTotalBalanceLabel,
  balance,
  onToggleShowHideBalance,
  hideBalances,
}: Props) {
  return (
    <div>
      <IconButton
        variant="primary"
        size="sm"
        icon={
          hideBalances ? (
            <>
              <EyeClosed />
              <span className="screen-reader-text">hide</span>
            </>
          ) : (
            <>
              <EyeOpened />
              <span className="screen-reader-text">show</span>
            </>
          )
        }
        onClick={onToggleShowHideBalance}
      />
      <span className="d-inline-block">
        <span className="d-none d-sm-inline-block font-weight--regular font--md pr-3">
          {breakdownTotalBalanceLabel}
        </span>
        <span className="h6 text--base" data-testid="balance-default-currency">
          {hideBalances ? getHiddenAmount('$', 'USDC') : balance}
        </span>
      </span>
    </div>
  );
};

export default Balance;
